import React, {memo} from 'react';

import {WBAgentPanelSearchContextSlice} from '../../aria/externalBindings/WBAgentContextSlices';
import {LoaderProxy} from '../../containers/AppLoader';
import {PanelBankContextProvider} from '../../state/panelbank/context';
import {PanelSurfaceProvider} from '../Panel/PanelSurfaceContext';
import {useAutoSyncPanelBankContext} from './contextProviders/AutoSyncPanelBankContext';
import {PanelBankSectionsDuringSearchProvider} from './contextProviders/PanelBankSectionsDuringSearch';
import {PanelBankConfigWithRefsProvider} from './hooks/usePanelBankConfigWithRefs';
import {PanelBankLayout} from './PanelBankLayout';
import {PanelBankSearchResultsProvider} from './search/PanelBankSearchResultsContext';
import type {PanelBankProps} from './types';

export const PanelBank = memo(function PanelBank(props: PanelBankProps) {
  const {isLoading} = useAutoSyncPanelBankContext();

  return (
    <PanelSurfaceProvider surface="workspace">
      <PanelBankContextProvider>
        <WBAgentPanelSearchContextSlice />
        {isLoading ? (
          <LoaderProxy name="use-auto-sync-panel-bank-loader" />
        ) : (
          <PanelBankConfigWithRefsProvider>
            <PanelBankSearchResultsProvider>
              <PanelBankSectionsDuringSearchProvider>
                <PanelBankLayout {...props} />
              </PanelBankSectionsDuringSearchProvider>
            </PanelBankSearchResultsProvider>
          </PanelBankConfigWithRefsProvider>
        )}
      </PanelBankContextProvider>
    </PanelSurfaceProvider>
  );
});
